import { findKeyByPath } from "@utils";
import { inject, observer } from "mobx-react";
import ButtonUI from "@UI/ButtonUI";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import logo from "./img/logo.svg";
import ListMenu from "./ListMenu";

import "./style.scss";
import { useNavigationHandler } from "@hook";

const LeftMenu = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigate = useNavigationHandler();
        const location = useLocation();
        const { firstParam } = useParams();

        const [activeKey, setActiveKey] = useState(null);
        const [expandedKeys, setExpandedKeys] = useState({});

        // console.log(activeKey);

        const getNormalizedPathname = () => {
            const base = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
            const pathname = location.pathname || "/";
            if (base && base !== "/" && pathname.startsWith(base)) {
                const cut = pathname.slice(base.length);
                return cut ? cut : "/";
            }
            return pathname;
        };

        useEffect(() => {
            const normalized = getNormalizedPathname();

            const found = findKeyByPath(menuItems, normalized);

            if (found) {
                setActiveKey(found.key);
                if (found.parentKey) {
                    setExpandedKeys({ [found.parentKey]: true });
                }
            }
        }, [location.pathname]);

        const handleSelect = (e, node) => {
            if (node.path) {
                if (!node.path.includes(firstParam)) mainStore.setDefaultFilter();
                setActiveKey(node.key || firstParam);
                navigate(e.originalEvent, node.path);
            }
        };

        const handleLogOut = () => {
            mainStore.logOut();
        };

        const handleLogoClick = (e) => {
            navigate(e, "/");
        };

        return (
            <div className="menu">
                <div className="menu__header">
                    <img src={logo} onClick={handleLogoClick} className="menu__logo" />
                </div>
                <ListMenu items={menuItems} onSelect={handleSelect} activeKey={activeKey} expandedKeys={expandedKeys} setExpandedKeys={setExpandedKeys} />
                <div className="menu__button-exit">
                    <ButtonUI label="Выйти" link icon="pi pi-sign-out" iconPos="left" onClick={handleLogOut} />
                </div>
            </div>
        );
    }),
);

const menuItems = [
    [
        {
            key: "0",
            label: "Витрины",
            path: "/projects",
        },
        {
            key: "1",
            label: "Вендоры",
            path: "/offers",
        },
        {
            key: "2",
            label: "Офферы",
            path: "/companies",
        },
        {
            key: "3",
            label: "Корзины",
            children: [
                { key: "3-0", label: "Добавить", path: "/buckets-add" },
                { key: "3-1", label: "Достать", path: "/buckets-get" },
            ],
        },
        {
            key: "4",
            label: "АБ тесты",
            children: [
                { key: "4-0", label: "Тест для оффера", path: "/test-offer" },
                { key: "4-1", label: "Замена данных", path: "/replace-data" },
                { key: "4-2", label: "Тест для сайта", path: "/test-site" },
            ],
        },
        { key: "5", label: "Лего", path: "/lego" },
    ],
    { type: "divider" },
    [
        {
            key: "6",
            label: "Активации",
            children: [
                { key: "6-0", label: "Ввод активаций", path: "/activate" },
                { key: "6-1", label: "Загруженные", path: "/uploaded-activations" },
            ],
        },
        {
            key: "7",
            label: "Выгрузка",
            children: [
                { key: "7-0", label: "Активированные промо", path: "/unload-promo" },
                { key: "7-1", label: "Лиды", path: "/unload-leads" },
                { key: "7-2", label: "Выдача тотал", path: "/unload-total" },
            ],
        },

        {
            key: "8",
            label: "Калькулятор СП",
            path: "/position-calculator",
        },
    ],
];

export default LeftMenu;
